"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var Icon_1 = tslib_1.__importDefault(require("../Icon"));
var VideoSolid = function (props) {
    return ((0, jsx_runtime_1.jsxs)(Icon_1.default, tslib_1.__assign({}, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: 'M16 54C16 48.4772 20.4772 44 26 44H118C123.523 44 128 48.4772 128 54V138C128 143.523 123.523 148 118 148H26C20.4772 148 16 143.523 16 138V54Z' }), (0, jsx_runtime_1.jsx)("path", { d: 'M159.146 133.138L140 115.118V76.8823L159.146 58.8622C165.528 52.8559 176 57.3805 176 66.1442V125.856C176 134.619 165.528 139.144 159.146 133.138Z' })] })));
};
/**
 * @deprecated Use Icon from Antd
 * https://ant.design/components/icon/
 */
exports.default = VideoSolid;
